import React from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import personIcon from '../../../imgs/post.svg';
import {ArrowTopIcon} from '../SvgIcons/SvgIcons';
import departmentIcon from '../../../imgs/departmenticon.svg';

const ChatCard = ({channelData}) => {
  const history = useHistory();

  const handleSubmit = () => {
    history.push({
      pathname: '/inbox',
      state: {channelData},
    });
  };

  const userProfile = useSelector((state) => state.strapiRes);

  return (
    <div
      className={`chat-card-wrapper ${
        channelData?.offers?.channelId?.unread?.id === userProfile?.id
          ? 'unread'
          : null
      } `}
      onClick={() => handleSubmit()}>
      <div className="offer-card-top">
        <h2 className="heading">
          @{channelData.offers?.introPerson?.firstName}
          {channelData.offers?.introPerson?.lastName}
        </h2>
        <h2 className="small-heading">
          {channelData?.offers?.bountyId?.bountyType === 'company' ? (
            <img src={departmentIcon} alt="departmentIcon" className="mr-1" />
          ) : (
            <img src={personIcon} alt="personIcon" className="mr-1" />
          )}
          {channelData.offers?.bountyId?.bountyType === 'company' ? channelData.offers?.bountyId?.company : channelData.offers?.bountyId?.fullName}
        </h2>
      </div>
      <div className="row m-0 justify-content-between">
        <p className="grey">
          {channelData?.lastMessage?.user?.id === userProfile.id ? (
            <span className="you-frame">you</span>
          ) : null}
          {channelData?.lastMessage?.message}
        </p>
        <ArrowTopIcon />
      </div>
    </div>
  );
};

export default ChatCard;
